import { z } from "zod";

export const googleOAuthCallbackSchema = z.object({
	id_token: z.string(),
});

export type GoogleOAuthCallbackPayload = z.infer<typeof googleOAuthCallbackSchema>;
